import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'

import styles from './styles.module.scss'

const TeamContactsComponent = ({
  teamOfOrganizer,
  contacts,
  information,
  useEventBodyBg = true,
}) => {
  const titleMessage = useMemo(() => {
    if (teamOfOrganizer) return <FormattedMessage id='id.teams.title' />
    if (contacts)
      return <FormattedMessage id='community.list.description.contacts' />

    return null
  }, [teamOfOrganizer, contacts])

  const informationItems = useMemo(() => {
    if (!information?.length) return null

    return information.map((el, index) => (
      <div key={index} className={styles.events__organizer__team__container}>
        <h1 className={styles.organizer__card__title}>
          {el?.name ? el?.name : 'name'} :
        </h1>
        <div className={styles.organizer__card}>
          <p className={styles.organizer__card__title}>
            {el?.title ? el?.title : 'title'}
          </p>
        </div>
      </div>
    ))
  }, [information])

  const articleClassName = useMemo(
    () =>
      classNames(
        useEventBodyBg ? 'eventBodyBg' : '',
        styles.events__organizer__team
      ),
    [useEventBodyBg]
  )

  return (
    <>
      <h4 className={styles.events__about__title}>{titleMessage}</h4>
      <article className={articleClassName}>{informationItems}</article>
    </>
  )
}

export default TeamContactsComponent
